import { useState, useEffect } from "react";
import { FieldEditControls } from "components/FieldEditControls/FieldEditControls";
import "./RadioField.scss";

const RadioField = (props: any) => {
  const {
    defaultValue,
    editable,
    label,
    editPath,
    onChange,
    options = [],
    //recordId,
    //readonly,
    name,
    mode
  }: any = props;
  const [value, setValue] = useState(defaultValue as any);
  const [isEditEnabled, setIsEditEnabled] = useState(false);


  useEffect(() => {
    if (onChange) onChange(value);
  }, [value]);
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  const handleClick = (index: number) => {
    setValue(options[index].name);
  };

  function getDisplayNameByName(name: string) {
    const option = options.find((option: any) => option.name === name);
    return option ? option.displayName : null;
  }
  return (
    <div className="radio-field-container">
      <div className="field-header">
        {label && (
          <label>
            <span>{label}</span>
          </label>
        )}
        {editable && (
          <div>
            {(mode == 'edit' && editable) && (
              <FieldEditControls
                value={value}
                fieldName={name}
                editPath={editPath}
                onEditStart={() => {
                  setIsEditEnabled(true);
                }}
                onEditCancel={(originalValue) => {
                  setIsEditEnabled(false);
                  setValue(originalValue);
                }}
                onEditEnd={(success: boolean, originalValue) => {
                  setIsEditEnabled(false);
                  if (!success) {
                    setValue(originalValue);
                  }
                }}
              />
            )}
          </div>
        )}
      </div>
      <div className="field-body">
        <div>
          {mode == 'readonly' ||
            (mode == 'edit' && editable && !isEditEnabled) ||
            (mode == 'edit' && !editable) ? (
            <div className="readonly-content">
              <div>
                <span>{getDisplayNameByName(value)}</span>
              </div>
            </div>
          ) : (
            <div className="editable-content">
              {options.map((option: any, index: any) => {
                return (
                  <a
                    key={index}
                    onClick={() => handleClick(index)}
                    className={value == option.name ? "actived" : ""}
                  >
                    <span>{option?.displayName}</span>
                  </a>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export { RadioField };
